/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/24/ctrl-right': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M8.809 23.588l-1.617-1.176L14.764 12 7.191 1.588 8.808.412l8 11a1 1 0 010 1.176l-7.999 11z" _fill="#272c33"/>'
  }
})
